import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: 5,
        '&.active': {
            backgroundColor: theme.colors.gray[0],
        },
    },
    headline: {
        padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
        '& > *': {
            margin: 0,
            lineHeight: theme.spacing(4),
        },
    },
    content: Object.assign(Object.assign({}, theme.typography.body2), { padding: theme.spacing(2) }),
    cardActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
        borderTop: `1px solid ${theme.colors.gray[200]}`,
        '& > *': {
            marginLeft: theme.spacing(1),
        },
    },
}));
//# sourceMappingURL=Card.styles.js.map